// @TODO CW-1385 remove when pricing-sdk publishes updates to GetNextInteractionResponse

export var ProductActionMap = /*#__PURE__*/function (ProductActionMap) {
  ProductActionMap["BUNDLE"] = "CSP";
  ProductActionMap["CHEGG_STUDY"] = "CS";
  ProductActionMap["CHEGG_MATH"] = "MATH";
  ProductActionMap["EASYBIB"] = "EB";
  ProductActionMap["WRITING_TOOLS"] = "EB";
  ProductActionMap["CENGAGE_UNLIMITED"] = "";
  ProductActionMap["MHE_BUNDLE"] = "";
  ProductActionMap["PROMOTIONS"] = "";
  ProductActionMap["MATHWAY"] = "MATHWAY";
  ProductActionMap["CHEGG_WRITING"] = "CW";
  ProductActionMap["CITATIONMACHINE"] = "CM";
  ProductActionMap["CTFM"] = "CTFM";
  ProductActionMap["BIBME"] = "BM";
  return ProductActionMap;
}({});
export var ProductName = /*#__PURE__*/function (ProductName) {
  ProductName["CHEGG_STUDY"] = "STUDY";
  ProductName["CHEGG_STUDY_PACK"] = "STUDY_PACK";
  return ProductName;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/OneClick/interfaces.js
// module id = 1541
// module chunks = 11